<div *ngIf="transaction.isCash">
    <p>
    {{ transaction.method.instructions }}
    </p>

    <h3 i18n>Your reference</h3>
    <p><strong>{{ transaction.reference }}</strong></p>

    <h3 i18n>Full amount</h3>
    <p><strong>{{ transaction.amount | currency: transaction.currency.code }}</strong></p>

    <ng-container *ngTemplateOutlet="buttons"></ng-container>
</div>
<div *ngIf="transaction.isCheque">
    <p>
    {{ transaction.method.instructions }}
    </p>

    <h3 i18n>Your reference</h3>
    <p><strong>{{ transaction.reference }}</strong></p>

    <h3 i18n>Full amount</h3>
    <p><strong>{{ transaction.amount | currency: transaction.currency.code }}</strong></p>

    <ng-container *ngTemplateOutlet="buttons"></ng-container>
</div>
<div *ngIf="transaction.isTransfer">
    <p [innerHtml]="transaction.method.instructions">
    </p>

    <h3 i18n>Your reference</h3>
    <p><strong>{{ transaction.reference }}</strong></p>

    <h3 i18n>Full amount</h3>
    <p><strong>{{ transaction.amount | currency: transaction.currency.code }}</strong></p>

    <ng-container *ngTemplateOutlet="buttons"></ng-container>
</div>

<!-- Buttons shared template -->
<ng-template #buttons>
    <p i18n>When you have made your payment please let us know by returning to this page and clicking the button below.</p>
    <ub-button-list>
        <button mat-flat-button
                color="primary"
                type="button"
                [disabled]="isOperationInProgress"
                (click)="onPaid()" i18n>I confirm I have sent payment</button>
        <button mat-flat-button
                color="secondary"
                type="button"
                [disabled]="isOperationInProgress"
                (click)="onLater()" i18n>Change payment method</button>
    </ub-button-list>
</ng-template>
<!-- /Buttons shared template -->
